/**
 * Header Scroll Effect
 * Adds solid background class when scrolling past 100px
 */
document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('header');
  if (!header) return;

  window.addEventListener('scroll', function() {
    if (window.scrollY > 100) {
      header.classList.add('solid');
    } else {
      header.classList.remove('solid');
    }
  });
});

